import * as UsersList from './list';
import * as UserForm from './form';

const reducers = {
  ...UsersList,
  ...UserForm,
};

export default reducers;
